<template>
	<div>
		<template v-if="$route.params.withdraw == 'pay'">
			<img width="30%" src="static/assets/img/jeton-kart.png"/>
			<jetonForm />
			<h4 class="mt-2">Güncel Jeton hesaplarımızı lütfen Canlı Destek üzerinden isteyiniz.</h4>
		</template>
		<template v-if="$route.params.withdraw == 'withdraw'">
			<jetonWithdraw />
		</template>
	</div>
</template>

<script>
	import jetonForm from '@/components/payments/form/jeton'
    import jetonWithdraw from '@/components/payments/form/jetonWithdraw'
    export default {
        name: "jeton",
        components: {jetonWithdraw, jetonForm}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/jeton.vue